<template>
  <div class="body">
    <van-nav-bar
      title="购物车"
      :right-text=" delet ? '取消':'编辑' "
      @click-right="onClickRight"
      class="topNav"
    />
    <div class="content animated fadeInRight fast" v-if="hasData">
      <div class="itemWrap" v-for="(item,index) in list" :key="index">
        <div class="itemLeft">
          <van-checkbox v-model="item.checked" checked-color="#e9aea8" class="LeftIcon"></van-checkbox>
        </div>
        <div class="itemRight">
          <div class="msg">
            <div class="msgLeft" @click="Jump(item.id)">
              <img :src="item.img | thumbnail(180,180)">
            </div>
            <div class="msgRight">
              <div class="msgTitle">
                <div class="msgName" @click="Jump(item.id)">{{item.name}}</div>
                <div class="msgDes"></div>
              </div>
              <div class="msgBottom">
                <div class="msgPrice">￥{{item.price}}</div>
                <div class="msgNum">
                  <van-stepper
                    v-model="item.num"
                    @plus="plus(item.id,item.skuid,index)"
                    @minus="minus(item.id,item.skuid,index)"
                    :disable-input="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hasData">
      <NoData msg="亲,暂无订单"/>
    </div>
    <SubBar @selAll="selAll" @sub="sub" @del="del" :price="price" :delet="delet"/>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import SubBar from "@/components/SubBar.vue";
import {
  GetAddress,
  CartList,
  CartSub,
  CartAdd,
  CertDel
} from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { checkToken, checkAgree } from "../../utils/token.js";
// import { thumbnail } from "../../filters/index.js";
import { SubmitBar, Checkbox, CheckboxGroup, Stepper, Dialog } from "vant";
import Vue from "vue";
Vue.use(SubmitBar)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Stepper);
export default {
  components: {
    NoData,
    SubBar
  },
  data() {
    return {
      delet: false,
      hasData: false,
      token: "",
      list: [],
      values: 0
    };
  },
  computed: {
    price() {
      let price = 0.00;
      for (let i in this.list) {
        if (this.list[i].checked) {
          let num = (parseFloat(price) +
            parseFloat(this.list[i].price) * parseFloat(this.list[i].num));
          price = num.toFixed(2);
        }
      }
      return price;
    }
  },
  created() {},
  activated() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // if (!checkToken()) {
    //   this.$router.push("/login");
    // } else {
    // if (!checkAgree(this.token)) {
    this.token = getLocalStorage("login_token");
    this.getCartList(this.token);
    // }
    // }
  },
  methods: {
    onClickRight() {
      this.delet = !this.delet;
    },
    onSubmit() {},
    getCartList(token) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      CartList(token)
        .then(res => {
          // if (res.code == 1) {
          this.$toast.clear();
          let data = res.data.goods_list;
          if (data.length > 0) this.hasData = true;
          this.list = [];
          for (let i in data) {
            this.list.push({
              id: data[i].goods_id,
              skuid: data[i].goods_sku_id,
              name: data[i].goods_name,
              img: data[i].goods_image,
              price: data[i].goods_price,
              num: data[i].total_num,
              checked: false
            });
          }
          // }
        })
        .catch(e => {});
    },
    selAll(check) {
      for (let i in this.list) {
        this.list[i].checked = check;
      }
    },
    sub() {
      let arr = "";
      for (let i in this.list) {
        if (this.list[i].checked) {
          arr += this.list[i].id + "_" + this.list[i].skuid + ",";
        }
      }
      if (arr.length > 0) {
        this.$store.commit("ORDER", {
          ids: arr.substring(0, arr.length - 1)
        });
        this.$router.push({
          name: "cartsub" // 路由的名称
        });
      }
    },
    plus(id, skuid, index) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      CartAdd(id, skuid, this.token, 1).then(res => {
        this.$toast.clear();
        if (res.code == 0) {
          this.list[index].num = this.list[index].num - 1;
          this.$toast.fail(res.msg);
        } else if (res.code == -1) {
          this.$toast.fail("未知错误");
        }
      });
    },
    minus(id, skuid, index) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
      CartSub(id, skuid, this.token).then(res => {
        this.$toast.clear();
        if (res.code == 0) {
          this.list[index].num = this.list[index].num + 1;
          this.$toast(res.msg);
        }
      });
    },
    Jump(id) {
      this.$router.push({
        name: "detail", // 路由的名称
        query: {
          id: id
        }
      });
    },
    del() {
      Dialog.confirm({
        title: "提示",
        message: "是否删除宝贝"
      })
        .then(() => {
          // on confirm
          let arr = "";
          for (let i in this.list) {
            if (this.list[i].checked) {
              arr += this.list[i].id + "_" + this.list[i].skuid + ",";
            }
          }
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
          CertDel(arr.substring(0, arr.length - 1), this.token)
            .then(res => {
              this.$toast.clear();
              this.$router.go(0);
            })
            .catch(e => {});
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  margin-bottom: 50px;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 50px;
  }
  .subbar {
    position: fixed;
    bottom: 50px;
  }
  .itemWrap {
    display: flex;
    padding: 13px 10px;
    background: @white;
    border-bottom: 1px solid #f4f4f4;
    .itemLeft {
      text-align: center;
      width: 30px;
      position: relative;
      .LeftIcon {
        line-height: 90px;
      }
    }
    .itemRight {
      flex: 1 1 auto;
      // max-width: 235px;
      .msg {
        display: flex;
        .msgLeft {
          width: 90px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            float: left;
          }
        }
        .msgRight {
          flex: 1 1 auto;
          max-width: 235px;
          padding: 0px 10px;
          .msgTitle {
            height: 60px;
            .msgName {
              font-size: 14px;
              color: @darkP;
            }
            .msgDes {
              font-size: 12px;
              color: @lightP;
            }
          }
          .msgBottom {
            // display: flex;
            height: 30px;
            width: 100%;
            overflow: hidden;
            .msgPrice {
              font-size: 14px;
              line-height: 30px;
              float: left;
              color: @text;
              // vertical-align:
            }
            .msgNum {
              flex: 1 1 auto;
              float: right;
            }
          }
        }
      }
    }
  }
}
@media (device-height: 812px) and (device-width: 375px) {
  .SubWrap {
    bottom: 2.133333rem !important;
  }
  .footer {
    height: 2.133333rem !important;
    padding-bottom: 0.8rem !important;
    background: #fff;
  }
}
</style>
<style>
.frame {
  padding: 0px !important;
}
.van-nav-bar__text {
  color: #000 !important;
}
</style>
